<template>
    <v-dialog
        :value="value"
        :max-width="max_width"
        :persistent="persistent"
        @input="$emit('input', $event)"
    >
        <v-card>
            <v-card-title :class="`headline ${header_color} white--text pl-5 pt-3`">
                <v-icon v-if="icon" left color="white">{{ icon }}</v-icon>
                <slot name="title">{{ title }}</slot>
            </v-card-title>
            
            <v-card-text class="pt-5">
                <slot></slot>
            </v-card-text>
            
            <v-card-actions class="shaded-light pa-4">
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Generic dialog that has a prominent header with an icon and title, along with 
 * a blank content area and shaded action area.
 */

export default {
    name: 'RcInfoDialog',
    
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'mdi-information'
        },
        header_color: {
            type: String,
            default: 'primary'
        },
        max_width: {
            type: [String, Number],
            default: '600'
        },
        persistent: {
            type: Boolean,
            default: true
        }
    }
}
</script>
